import { Component, inject } from '@angular/core';
import { NOTIFICATION_INDEX } from '../common';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-ui-notification',
  templateUrl: './ui-notification.component.html',
  styleUrls: ['./ui-notification.component.scss'],
})
export class UiNotificationComponent {
  private readonly platform = inject(Platform);
  readonly baseZIndex = NOTIFICATION_INDEX;

  get isMobile(): boolean {
    return this.platform.ANDROID || this.platform.IOS;
  }
}
